// AdminNav — secondary navigation strip rendered at the top of every
// /admin* page. Tables, Assign, Preview, Continuations.

import { NavLink } from 'react-router-dom';

export function AdminNav() {
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-1.5 text-xs tracking-[0.15em] uppercase transition-colors ${
      isActive
        ? 'bg-forest text-cream'
        : 'text-forest/80 hover:text-forest hover:bg-forest/10'
    }`;

  return (
    <div className="border-b border-forest/15 bg-cream-alt">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-2 flex items-center gap-1 flex-wrap">
        <span className="text-[10px] tracking-[0.25em] uppercase text-rose mr-3">Admin</span>
        <NavLink to="/admin" end className={linkClass}>Tables</NavLink>
        <NavLink to="/admin/assign" className={linkClass}>Assign</NavLink>
        <NavLink to="/admin/preview" className={linkClass}>Preview</NavLink>
        <NavLink to="/admin/continuations" className={linkClass}>Continuations</NavLink>
      </div>
    </div>
  );
}
